import React from 'react';
import { twMerge } from '@/utils';
import StandardButton from './StandardButton';

export interface ISubmitButtonProps {
  color?: ButtonColors;
  children?: ReactChildren;
  className?: string;
  disabled?: boolean;
  label?: string;
  onClick?: () => void;
  small?: boolean;
  submitting?: boolean;
  submittingText?: string;
  variant?: 'rounded-right';
}

const SubmitButton = ({
  color = 'purple',
  children,
  className = '',
  disabled = false,
  label = '',
  onClick = () => {},
  small = false,
  submitting = false,
  submittingText = 'Submitting…',
  variant,
}: ISubmitButtonProps) => {
  if (submitting) {
    return (
      <StandardButton
        aria-disabled
        className={twMerge('disabled', className)}
        color={color}
        label={label}
        small={small}
        // AIDEV-NOTE: type="submit" so Enter in a field clicks this button; the canceled click blocks resubmits.
        type="submit"
        variant={variant}
        onClick={e => e.preventDefault()}
      >
        <i aria-hidden="true" className="fa fa-spinner fa-spin" />
        {' '}
        {submittingText}
      </StandardButton>
    );
  }

  return (
    <StandardButton
      className={className}
      color={color}
      disabled={disabled}
      label={label}
      small={small}
      type="submit"
      variant={variant}
      onClick={onClick}
    >
      {children}
    </StandardButton>
  );
};

export default SubmitButton;
